import { call, put, select } from 'redux-saga/effects'
import { takeLatest } from 'redux-saga'
import compressProject from 'helpers/projects/compressProject'
import createDocumentSaga from 'sagas/createDocumentSaga'
import { notifyHoneybadgerAction, waitForMapIdleAction } from 'actions/applicationActions'
import { DUPLICATE_PROJECT } from 'actions/projectActionTypes'
import { autosaveSelector } from 'selectors'
import { deviceCountSelector } from 'selectors/components'
import clearMapComponents from 'helpers/map/clearMapComponents'
import { addProjectAction, expandProjectAction, updateProjectAction } from 'actions/projectActions'
import uuid from 'uuid'
import initialProject from 'helpers/projects/initialProject'

function * duplicateProjectSaga({ document, action }) {
  try {
    // nearly a copy pasta from autosaveSaga
    const { currentEntity, currentProjectMetadata, cameras, map,
      ui, projects, createdAt, entities } = yield select(autosaveSelector)
    const deviceCount = yield select(deviceCountSelector)

    const dup = yield call(compressProject, {
      mapLocation: map.location,
      zoom: map.zoom,
      markups: map.markups,
      floorPlans: map.floorPlans,
      mapType: map.mapType,
      title: `${projects
                .find(p => p.id === currentProjectMetadata._id)
                .title} Copy`,
      cameras,
      entities,
      ui,
      createdAt,
      updatedAt: Date.now(),
      currentEntity
    })

    const document = { ...initialProject(), ...dup, _id: uuid.v4() }
    const idAndRev = yield call(createDocumentSaga, document)
    const project = { ...document, ...idAndRev }

    yield put(updateProjectAction({ deviceCount }))
    yield call(clearMapComponents, { map, cameras })

    yield put(waitForMapIdleAction(map.ref))

    yield put(addProjectAction(project))
    yield put(expandProjectAction(project))
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

export default function * watchDuplicateProjectSaga() {
  yield * takeLatest(DUPLICATE_PROJECT, duplicateProjectSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/duplicateProjectSaga.js